/**
 * How an audience key reads on screen.
 *
 * Shared between the list and the modal — the two showed the same key and would
 * have drifted the first time one of them was edited.
 */
export const AUDIENCE_LABELS: Record<string, string> = {
  'consumer-subscribed': 'Skida app — subscribed',
  'consumer-never-asked': 'Skida app — never asked',
  'pro-members': 'Skida PRO — everyone',
  'pro-admins': 'Skida PRO — admins',
  'ambassadors-active': 'Active ambassadors',
  'partners-active': 'Active partners',
  'leads-cold': 'Cold leads — verified',
  'leads-cold-unverified': 'Cold leads — unverified',
  nobody: 'Nobody',
}
